import {
	ClientConstructionSite,
	ConstructionSitesTabProps,
	PAGES,
} from "@dune/types";
import { DataTable } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetClientConstructionSites } from "../../../api/queries/clients.queries";
import { clientConstructionSiteColumns } from "./constructionSiteTab/ConstructionSiteColumns";

const ConstructionSitesTab: React.FC<ConstructionSitesTabProps> = ({
	client,
}) => {
	const navigate = useNavigate();

	const {
		data: constructionSites = [],
		isLoading,
		error,
	} = useGetClientConstructionSites(
		client.id.toString(),
		client.clientType || undefined,
	);

	const columns = clientConstructionSiteColumns();

	const handleRowClick = (constructionSite: ClientConstructionSite) => {
		navigate(PAGES.PROJECTS.show.withParams(constructionSite.id.toString()));
	};

	if (error) {
		return (
			<div className="p-6">
				<div className="text-red-600">
					Erreur lors du chargement des chantiers: {error.message}
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center justify-between mb-6">
				<div className="text-2xl font-semibold text-gray-900">Chantiers</div>
			</div>

			<DataTable
				data={constructionSites}
				columns={columns}
				isLoading={isLoading}
				onRowClick={handleRowClick}
				noResultsText="Aucun chantier"
			/>
		</div>
	);
};

export default ConstructionSitesTab;
